import { render } from "./TabelaRequisitos.vue?vue&type=template&id=45815e2c&scoped=true"
import script from "./TabelaRequisitos.vue?vue&type=script&scoped=true&lang=js"
export * from "./TabelaRequisitos.vue?vue&type=script&scoped=true&lang=js"

import "./TabelaRequisitos.vue?vue&type=style&index=0&id=45815e2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45815e2c"]])

export default __exports__